// extracted by mini-css-extract-plugin
export default {"rating":"Ix-z","numberOfStars":"Jx-z","count":"Kx-z","barGraphSpacing":"Lx-z","barGraph":"Mx-z"};